import { render, staticRenderFns } from "./DataStrategy.vue?vue&type=template&id=532daa76&lang=pug"
import script from "./DataStrategy.vue?vue&type=script&lang=js"
export * from "./DataStrategy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('532daa76')) {
      api.createRecord('532daa76', component.options)
    } else {
      api.reload('532daa76', component.options)
    }
    module.hot.accept("./DataStrategy.vue?vue&type=template&id=532daa76&lang=pug", function () {
      api.rerender('532daa76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/data_strategy/DataStrategy.vue"
export default component.exports